var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 24 24",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m1.336 10.273 2.567 11.454h16.344l2.567-11.454-6.074 3.675-4.403-7.806-4.813 7.806Z",
    fill: "#ec9312",
    style: {
      strokeWidth: 0.0234375
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.743 4.966a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0",
    fill: "#cb1b5b",
    style: {
      strokeWidth: 0.0234375
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.243 2.466a2.499 2.499 0 1 0 0 5z",
    fill: "#e5226b",
    style: {
      strokeWidth: 0.0234375
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.336 10.273 2.567 11.454h16.344Z",
    fill: "#f4a832",
    style: {
      strokeWidth: 0.0234375
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.814 10.273-2.567 11.454H3.903Z",
    fill: "#f4a832",
    style: {
      strokeWidth: 0.0234375
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.903 21.727h16.344l-8.172-4.95z",
    fill: "#f5b617",
    style: {
      strokeWidth: 0.0234375
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.856 9.596a1.294 1.294 0 0 1-1.295 1.294 1.293 1.293 0 0 1-1.294-1.294 1.294 1.294 0 0 1 1.294-1.295 1.294 1.294 0 0 1 1.295 1.295",
    fill: "#0472af",
    style: {
      strokeWidth: 0.0234375
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.56 8.301a1.294 1.294 0 0 0-1.293 1.295 1.293 1.293 0 0 0 1.294 1.294z",
    fill: "#1a8dcc",
    style: {
      strokeWidth: 0.0234375
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.734 9.596A1.294 1.294 0 0 1 1.44 10.89 1.294 1.294 0 0 1 .144 9.596a1.294 1.294 0 0 1 1.295-1.295 1.294 1.294 0 0 1 1.295 1.295",
    fill: "#0472af",
    style: {
      strokeWidth: 0.0234375
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.439 8.301A1.294 1.294 0 0 0 .144 9.596a1.294 1.294 0 0 0 1.295 1.294Z",
    fill: "#0092d2",
    style: {
      strokeWidth: 0.0234375
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/Crown.68f44e9b.svg";
export { ForwardRef as ReactComponent };